import React from 'react';

/**
 * Reusable animated background component for marketing pages
 * Provides subtle animated orbs + grid overlay
 */
interface AnimatedBackgroundProps {
  /** Use fixed positioning instead of absolute (for auth pages) */
  fixed?: boolean;
  /** Use pointer-events-none (for auth pages) */
  pointerEventsNone?: boolean;
}

export function AnimatedBackground({
  fixed = false,
  pointerEventsNone = false,
}: AnimatedBackgroundProps = {}) {
  const containerClass = fixed
    ? `fixed inset-0 overflow-hidden ${pointerEventsNone ? 'pointer-events-none' : ''} z-0`
    : 'absolute inset-0 overflow-hidden';

  return (
    <div className={containerClass} aria-hidden="true">
      {/* Two soft, static glows anchored to the top — calmer than floating orbs */}
      <div className="absolute left-1/2 -top-40 h-[34rem] w-[60rem] -translate-x-1/2 rounded-full bg-[radial-gradient(circle_at_50%_40%,hsl(var(--brand-a)/0.16),transparent_65%)] blur-3xl" />
      <div className="absolute -right-40 top-0 h-[30rem] w-[30rem] rounded-full bg-[radial-gradient(circle_at_50%_50%,hsl(var(--brand-b)/0.10),transparent_60%)] blur-3xl" />

      {/* Fine grid, faded out toward the edges so it reads as texture, not noise */}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#ffffff0a_1px,transparent_1px),linear-gradient(to_bottom,#ffffff0a_1px,transparent_1px)] bg-[size:64px_64px] [mask-image:radial-gradient(900px_500px_at_50%_-5%,black,transparent_75%)]" />
    </div>
  );
}
